import { SettingsServicePaymentType } from '../../../../api/types/settings/payments/settings-service-payment-type';
import { toast } from 'react-toastify';
import appApi from '../../../../api/app-api';
import globalPaymentServices from '../../../../stores/global-payment-services';

export const addNewServiceOperation = async (
  serviceName: string,
  price: number | null,
  selectedPaymentServiceType: SettingsServicePaymentType | null,
  setLoading: (loading: boolean) => void,
  closeDialog: () => void,
) => {
  try {
    if (serviceName.length < 3 || isNaN(Number(price)) || Number(price) === 0) {
      toast.warn(
        'על שם השרות להיות מעל לשלושה תווים ועל המחיר להיות מספר תקין',
      );
      return;
    }

    if (!selectedPaymentServiceType) {
      toast.warn('יש לבחור סוג שרות');
      return;
    }

    setLoading(true);

    const createNewServiceRes = await appApi.addService(
      serviceName,
      Number(price),
      selectedPaymentServiceType.id,
    );
    globalPaymentServices.fetchPaymentService();

    toast.success('הפעולה בתהצעה בהצלחה');
    setLoading(false);
    closeDialog();
  } catch (e) {
    console.error(`Add new service is failed with the error: ${e}`);
    setLoading(false);
    toast.error('יצירת שרות התשלום נכשלה, נסה שוב בעוד מספר רגעים...');
  }
};
